import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import website from "../../website/data";
import "./css/HeroSection.css";

const HeroSection = ({ primaryBanners }) => {
	const arrowRef = useRef();
	const [banners, setBanners] = useState(null);

	var settings = {
		dots: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	return (
		<>
			{/* Desktop and Tablet  */}
			<div className="container-fluid hero-container">
				{/* Primary Banners from API */}
				{primaryBanners && primaryBanners.length > 0 && (
					<div className="container mb-3 mt-2">
						{primaryBanners.length === 1 ? (
							<a
								href={primaryBanners[0]?.url?.startsWith('http') ? primaryBanners[0].url : `https://${primaryBanners[0]?.url}` || '#'}
								target="_blank"
								rel="noreferrer"
								className="d-block w-100"
							>
								<img
									src={primaryBanners[0]?.image}
									alt={primaryBanners[0]?.title || 'banner'}
									className="d-block w-100"
									style={{ borderRadius: 8 }}
									loading="lazy"
								/>
							</a>
						) : (
							<Slider ref={arrowRef} {...settings}>
								{primaryBanners.map((banner, index) => (
									<div className="p-3" key={banner._id || index}>
										<a
											href={banner?.url?.startsWith('http') ? banner.url : `https://${banner?.url}` || '#'}
											target="_blank"
											rel="noreferrer"
											className="d-block w-100"
										>
											<img
												src={banner?.image}
												alt={banner?.title || 'banner'}
												className="d-block w-100"
												style={{ borderRadius: 8 }}
												loading="lazy"
											/>
										</a>
									</div>
								))}
							</Slider>
						)}
					</div>
				)}
				
				{/* Fallback to existing banner logic */}
				{(!primaryBanners || primaryBanners.length === 0) && banners?.length === 1 && (
					<img
						className="bannerimg"
						src={`${website.link}/${banners[0].image}`}
						onClick={() => window.open(`${banners[0].link}`)}
						alt=""
					/>
				)}
				{(!primaryBanners || primaryBanners.length === 0) && banners?.length > 1 && (
					<Slider ref={arrowRef} {...settings}>
						{banners &&
							banners?.map((item, index) => {
								return (
									<div className="p-3" key={index}>
										<Link to={item?.link} target="_blank">
											<img
												src={`${website.link}/${item.image}`}
												className="d-block w-100"
												alt="banners"
											/>
										</Link>
									</div>
								);
							})}
					</Slider>
				)}
			</div>
		</>
	);
};

export default HeroSection;
